"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { DEFAULT_LOCALE, LOCALES, getLocaleFromPath } from '@kkeut/lib/locale';

function langFromPath(pathname) {
  const locale = getLocaleFromPath(pathname);
  return LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
}

export default function HtmlLangSync() {
  const pathname = usePathname();
  const nextLang = langFromPath(pathname);

  useEffect(() => {
    if (document?.documentElement?.lang !== nextLang) {
      document.documentElement.setAttribute("lang", nextLang);
    }
  }, [nextLang]);

  return null;
}
